import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AddNewSectionDefinitionDto,
  AttributeDefinition,
  SectionDefinition,
  SectionDefinitionEntityType,
} from '../../../models/section-definition.model';
import { animate, style, transition, trigger } from '@angular/animations';
import { SectionDefinitionService } from '../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { parseEnumValue } from '../../../shared/enum-utils';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { slideToggle } from '../../../helpers/slidetoggle';
import { AttributeDefinitionService } from '../../../services/attributeDefinition.service';
import { UtilitySharedService } from '../../../services/shared//utility-shared.service';

@Component({
  selector: 'lib-data-model-customization-section',
  templateUrl: './data-model-customization-section.component.html',
  styleUrls: ['./data-model-customization-section.component.scss'],
  standalone: false,
  animations: [slideToggle],
})
export class DataModelCustomizationSectionComponent implements OnInit {
  @Input() section!: SectionDefinition;
  @Output() sectionSaved = new EventEmitter<{ type: number; id?: number, substationTemplateId?: number }>();
  @Output() sectionDeleted = new EventEmitter<number>();
  @Output() sectionUpdated = new EventEmitter<{ type: number; id?: number, substationTemplateId?: number }>();
  @Input() sectionExpanded: boolean = false;
  @Input() utilityId!: number | null;
  @Input() assetType!: SectionDefinitionEntityType;
  @Input() substationTemplateId?: number;

  addNewFieldOpened: boolean = false;
  editAttrId: number = 0;
  count: number = 0;
  isEditOpened: boolean = false;
  sectionToEdit!: AddNewSectionDefinitionDto;

  get showVoltageClass(): boolean {
    return (
      this.assetType != SectionDefinitionEntityType.Building &&
      this.assetType != SectionDefinitionEntityType.Customer &&
      this.assetType != SectionDefinitionEntityType.Pole
    );
  }

  constructor(
    private sectionDefinitionService: SectionDefinitionService,
    private attributeDefinitionService: AttributeDefinitionService,
    private toastr: ToastrService,
    private bpsUtilityService: UtilitySharedService
  ) {}

  ngOnInit(): void {
    this.section.attributeDefinitions.sort(
      (a, b) => a.displayOrder - b.displayOrder
    );
    this.count = this.section.attributeDefinitions.filter(x => !x.parentAttributeId).length;
  }

  save(deleted: boolean = false, enabled?: boolean) {
    var sectionDefinition = new AddNewSectionDefinitionDto(this.section);

    this.sectionDefinitionService.save(sectionDefinition, this.utilityId).subscribe({
      next: (response) => {
        if (response?.body?.status === 200 || response?.body?.status === 'OK') {
          if (deleted) this.toastr.success('Attribute deleted successfully.');
          else if (!enabled)
            this.toastr.success('Attribute saved successfully.');
          this.sectionSaved.emit({
            type: parseEnumValue(
              SectionDefinitionEntityType,
              sectionDefinition.assetType
            )!,
            id: this.section.id,
            substationTemplateId: this.substationTemplateId
          });
        } else {
          this.toastr.error(response?.body?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  editAttribute(id: number) {
    this.editAttrId = id;
    this.addNewFieldOpened = true;
  }

  deleteAttribute(id: number) {
    const obj = { id: id, utilityId: this.utilityId };
    this.attributeDefinitionService.canDelete(obj).subscribe({
      next: (response: any) => {
        if (response?.body?.data == true) {
          this.section.attributeDefinitions =
            this.section.attributeDefinitions.filter((x) => x.id !== id);
          this.section.attributeDefinitions.forEach((attr, index) => {
            attr.displayOrder = index + 1;
          });
          this.save(true);
        } else {
          this.toastr.error("This attribute has values and can't be deleted.");
        }
      }
    })

  }

  onDrop(event: CdkDragDrop<AttributeDefinition[]>) {
    if (this.section.id) {
      moveItemInArray(
        this.section.attributeDefinitions,
        event.previousIndex,
        event.currentIndex
      );

      this.section.attributeDefinitions.forEach(
        (attributeDefinition, index) => {
          attributeDefinition.displayOrder = index + 1;
        }
      );

      this.save();
    }
  }

  trackById(_: number, section: AttributeDefinition): number {
    return section.id!;
  }

  onDelete() {
    this.sectionDefinitionService.delete(this.section.id, this.bpsUtilityService.getUtilityId()).subscribe({
      next: (response: any) => {
        if (response?.body?.status == 200 || response?.body?.status == 'OK') {
          this.toastr.success(response?.body?.message);
          this.sectionDeleted.emit(this.section.id);
        }
        else
          this.toastr.error(response?.body?.message);
      }
    })
  }

  onEdit() {
    this.sectionToEdit = new AddNewSectionDefinitionDto(this.section);
    this.isEditOpened = !this.isEditOpened;
  }

  onSectionUpdated() {
    if (this.assetType != SectionDefinitionEntityType.SubstationTemplate)
      this.sectionUpdated.emit({type: this.assetType});
    else
      this.sectionUpdated.emit({type: this.assetType, substationTemplateId: this.substationTemplateId});
  }
}
